<template>
    <div class="nk-app-root">
        <!-- main @s -->
        <div class="nk-main ">
            <header class="header header-32 has-header-main-s1 bg-dark" id="home">
                <div class="header-main header-main-s1 is-sticky is-transparent on-dark">
                    <div class="container header-container">
                        <div class="header-wrap">
                            <div class="header-logo">
                                <a href="html/index.html" class="logo-link">
                                    <img class="logo-light logo-img" src="/images/logo.png" srcset="/images/logo2x.png 2x" alt="logo">
                                    <img class="logo-dark logo-img" src="/images/logo-dark.png" srcset="/images/logo-dark2x.png 2x" alt="logo-dark">
                                </a>
                            </div>
                            <div class="header-toggle">
                                <button class="menu-toggler" data-target="mainNav">
                                    <em class="menu-on icon ni ni-menu"></em>
                                    <em class="menu-off icon ni ni-cross"></em>
                                </button>
                            </div><!-- .header-nav-toggle -->
                            <nav class="header-menu" data-content="mainNav">
                                <ul class="menu-list ms-lg-auto">
                                    <li class="menu-item has-sub">
                                        <a href="#" class="menu-link menu-toggle">Landing</a>
                                        <div class="menu-sub">
                                            <ul class="menu-list">
                                                <li class="menu-item"><a href="html/index.html" class="menu-link">Landing Page - v1</a></li>
                                                <li class="menu-item"><a href="html/index-v2.html" class="menu-link">Landing Page - v2</a></li>
                                                <li class="menu-item"><a href="html/index-v3.html" class="menu-link">Landing Page - v3</a></li>
                                                <li class="menu-item"><a href="html/index-v4.html" class="menu-link">Landing Page - v4</a></li>
                                                <li class="menu-item"><a href="html/index-v5.html" class="menu-link">Landing Page - v5</a></li>
                                                <li class="menu-item"><a href="html/index-v6.html" class="menu-link">Landing Page - v6</a></li>
                                            </ul>
                                        </div>
                                    </li>
                                    <li class="menu-item has-sub">
                                        <a href="#" class="menu-link menu-toggle">Pages</a>
                                        <div class="menu-sub">
                                            <ul class="menu-list">
                                                <li class="menu-item has-sub">
                                                    <a href="#" class="menu-link menu-toggle">Auth Pages</a>
                                                    <div class="menu-sub">
                                                        <ul class="menu-list">
                                                            <li class="menu-item"><a href="html/pages/auths/auth-login.html" class="menu-link" target="_blank">Login / Signin</a></li>
                                                            <li class="menu-item"><a href="html/pages/auths/auth-login-v2.html" class="menu-link" target="_blank">Login / Signin v2</a></li>
                                                            <li class="menu-item"><a href="html/pages/auths/auth-login-v3.html" class="menu-link" target="_blank">Login / Signin v3</a></li>
                                                            <li class="menu-item"><a href="html/pages/auths/auth-register.html" class="menu-link" target="_blank">Register / Signup</a></li>
                                                            <li class="menu-item"><a href="html/pages/auths/auth-register-v2.html" class="menu-link" target="_blank">Register / Signup v2</a></li>
                                                            <li class="menu-item"><a href="html/pages/auths/auth-register-v3.html" class="menu-link" target="_blank">Register / Signup v3</a></li>
                                                            <li class="menu-item"><a href="html/pages/auths/auth-reset.html" class="menu-link" target="_blank">Forgot Password</a></li>
                                                            <li class="menu-item"><a href="html/pages/auths/auth-reset-v2.html" class="menu-link" target="_blank">Forgot Password v2</a></li>
                                                            <li class="menu-item"><a href="html/pages/auths/auth-reset-v3.html" class="menu-link" target="_blank">Forgot Password v3</a></li>
                                                        </ul>
                                                    </div>
                                                </li>
                                                <li class="menu-item has-sub">
                                                    <a href="#" class="menu-link menu-toggle">Error Pages</a>
                                                    <div class="menu-sub">
                                                        <ul class="menu-list">
                                                            <li class="menu-item"><a href="html/pages/errors/404-classic.html" target="_blank" class="menu-link">404 Classic</a></li>
                                                            <li class="menu-item"><a href="html/pages/errors/404-modern.html" target="_blank" class="menu-link">404 Modern</a></li>
                                                            <li class="menu-item"><a href="html/pages/errors/504-classic.html" target="_blank" class="menu-link">504 Classic</a></li>
                                                            <li class="menu-item"><a href="html/pages/errors/504-modern.html" target="_blank" class="menu-link">504 Modern</a></li>
                                                        </ul>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </li>
                                    <li class="menu-item"><a href="#home" class="menu-link nav-link">Home</a></li>
                                    <li class="menu-item"><a href="#feature" class="menu-link nav-link">Features</a></li>
                                    <li class="menu-item"><a href="#pricing" class="menu-link nav-link">Pricing</a></li>
                                    <li class="menu-item"><a href="#story" class="menu-link nav-link">Story</a></li>
                                </ul>
                                <ul class="menu-btns">
                                    <li>
                                        <a href="https://1.envato.market/e0y3g" target="_blank" class="btn btn-primary btn-lg">Download App</a>
                                    </li>
                                </ul>
                            </nav><!-- .nk-nav-menu -->
                        </div><!-- .header-warp-->
                    </div><!-- .container-->
                </div><!-- .header-main-->
                <div class="header-content py-6 is-dark mt-lg-n1 mt-n3">
                    <div class="container">
                        <div class="row flex-row-reverse justify-content-center text-center g-gs">
                            <div class="col-lg-6 col-md-7">
                                <div class="header-caption">
                                    <h1 class="header-title">Powelful Tool To Represent Your Dashboard.</h1>
                                    <p>A powerful admin dashboard template that especially build for developers and programmers. DashLite comes with all kind of components.</p>
                                    <ul class="header-action btns-inline py-3">
                                        <li>
                                            <a href="#" class="btn btn-primary btn-lg"><span>Get Started</span></a>
                                        </li>
                                        <li>
                                            <a href="#" class="btn btn-danger btn-lg"><span>View Demo</span></a>
                                        </li>
                                    </ul><!-- .header-action -->
                                    <ul class="header-icon list-inline pt-1">
                                        <li><img class="h-20px" src="/images/icon/libs/javascript.png" alt=""></li>
                                        <li><img class="h-20px" src="/images/icon/libs/sass.png" alt=""></li>
                                        <li><img class="h-20px" src="/images/icon/libs/gulp.png" alt=""></li>
                                        <li><img class="h-20px" src="/images/icon/libs/bootstrap.png" alt=""></li>
                                        <li><img class="h-20px" src="/images/icon/libs/html5.png" alt=""></li>
                                        <li><img class="h-20px" src="/images/icon/libs/css3.png" alt=""></li>
                                    </ul>
                                </div><!-- .header-caption -->
                            </div><!-- .col -->
                        </div><!-- .row -->
                    </div><!-- .container -->
                </div><!-- .header-content -->
            </header><!-- .header -->
            <section class="section section-service pb-0" id="feature">
                <div class="container">
                    <div class="row justify-content-center text-center">
                        <div class="col-sm-8 col-lg-6">
                            <div class="section-head">
                                <h2 class="title">Make Your Website Growth With Next Level Visitors</h2>
                            </div><!-- .section-head -->
                        </div><!-- .col -->
                    </div><!-- .row -->
                    <div class="section-content">
                        <div class="row justify-content-center text-center g-gs">
                            <div class="col-sm-8 col-md-6 col-lg-4">
                                <div class="service">
                                    <div class="service-icon styled-icon styled-icon-s4 styled-icon-6x circle text-primary">
                                        <svg x="0px" y="0px" viewBox="0 0 512 512" style="fill:currentColor" xml:space="preserve">
                                        <path style="fill:currentColor; opacity:.52;" d="M197.3,0h-160C16.7,0,0,16.7,0,37.3v96c0,20.6,16.7,37.3,37.3,37.3h160c20.6,0,37.3-16.8,37.3-37.3v-96
	C234.7,16.7,217.9,0,197.3,0z" />
                                        <path style="fill:currentColor" d="M197.3,213.3h-160C16.7,213.3,0,230.1,0,250.7v224C0,495.2,16.7,512,37.3,512h160c20.6,0,37.3-16.8,37.3-37.3
	v-224C234.7,230.1,217.9,213.3,197.3,213.3z" />
                                        <path style="fill:currentColor; opacity:.52;" d="M474.7,341.3h-160c-20.6,0-37.3,16.8-37.3,37.3v96c0,20.6,16.7,37.3,37.3,37.3h160c20.6,0,37.3-16.8,37.3-37.3
	v-96C512,358.1,495.2,341.3,474.7,341.3z" />
                                        <path style="fill:currentColor" d="M474.7,0h-160c-20.6,0-37.3,16.7-37.3,37.3v224c0,20.6,16.7,37.3,37.3,37.3h160c20.6,0,37.3-16.8,37.3-37.3
	v-224C512,16.7,495.2,0,474.7,0z" />
                                        </svg>
                                    </div><!-- .service-icon -->
                                    <div class="service-text">
                                        <h4 class="title">Friendly Design</h4>
                                        <p>Lorem ipsum dolor sit amet, conse ctetur adipisicing elit, sed do eiusm lod tempor incididunt ctechtner.</p>
                                    </div><!-- .service-text -->
                                </div><!-- .service -->
                            </div><!-- .col -->
                            <div class="col-sm-8 col-md-6 col-lg-4">
                                <div class="service">
                                    <div class="service-icon styled-icon styled-icon-s4 styled-icon-6x circle text-primary">
                                        <svg x="0px" y="0px" viewBox="0 0 512 512" style="fill:currentColor" xml:space="preserve">
                                        <path style="fill:currentColor" d="M486.9,71.7c-0.9-6.6-5.9-12-12.5-13.8L261.2,0.6c-3-0.8-6.2-0.8-9.3,0L38.7,57.9c-6.7,1.8-11.6,7.2-12.5,13.8
	C25,80.3-3.2,283,69.1,383.9C141.4,484.6,248,510.5,252.5,511.5c1.3,0.3,2.7,0.5,4.1,0.5c1.4,0,2.7-0.2,4.1-0.5
	c4.5-1,111.1-26.9,183.4-127.6C516.4,283,488.2,80.3,486.9,71.7z M394.1,190.1L248.6,330.4c-3.4,3.3-7.8,4.9-12.2,4.9
	s-8.9-1.6-12.2-4.9l-89.9-86.8c-3.3-3.1-5.1-7.4-5.1-11.8c0-4.4,1.8-8.7,5.1-11.8l17.8-17.2c6.8-6.5,17.7-6.5,24.5,0l59.8,57.7
	l115.3-111.3c3.3-3.1,7.7-4.9,12.2-4.9c4.6,0,9,1.8,12.2,4.9l17.8,17.2C400.8,172.9,400.8,183.5,394.1,190.1z" />
                                        </svg>
                                    </div><!-- .service-icon -->
                                    <div class="service-text">
                                        <h4 class="title">Strong Security</h4>
                                        <p>Lorem ipsum dolor sit amet, conse ctetur adipisicing elit, sed do eiusm lod tempor incididunt ctechtner.</p>
                                    </div><!-- .secvice-text -->
                                </div><!-- .service -->
                            </div><!-- .col- -->
                            <div class="col-sm-8 col-md-6 col-lg-4">
                                <div class="service">
                                    <div class="service-icon styled-icon styled-icon-s4 styled-icon-6x circle text-primary">
                                        <svg x="0px" y="0px" viewBox="0 0 512 512" style="fill:currentColor" xml:space="preserve">
                                        <g>
                                        <defs>
                                        <rect id="PIESVGID_1_" x="5.7" width="500.1" height="512" />
                                                </defs>
                                        <clipPath id="PIESVGID_2_">
                                        <use xlink:href="#PIESVGID_1_" style="overflow:visible;" />
                                                </clipPath>
                                        <g style="clip-path:url(#PIESVGID_2_);">
                                        <path style="fill:currentColor; opacity:.52;" d="M266.1,0c-5.8,0-10.4,4.8-10.4,10.7v234.4c0,5.9,4.7,10.7,10.4,10.7h229.2c5.8,0,10.4-4.8,10.4-10.7
			C505.6,109.8,398.4,0.1,266.1,0z" />
                                        <path style="fill:currentColor" d="M378.5,451.6L234.9,262.7V32c0-5.9-4.7-10.7-10.4-10.7C103.8,21.3,5.7,131.2,5.7,266.4
			C5.8,401.7,113,511.3,245.3,511.5c48,3.8,95.5-12.4,131.6-45.1C381.3,462.7,382,456.2,378.5,451.6z" />
                                        <path style="fill:currentColor; opacity:.7;" d="M495.3,277H287c-5.8,0-10.4,4.8-10.4,10.7c0,2.4,0.8,4.8,2.3,6.7l135.4,171.5c1.8,2.3,4.5,3.7,7.4,3.9h0.7
			c2.6,0,5.2-1,7.1-2.9c48.5-46.4,76.1-111.3,76.2-179.3C505.8,281.8,501.1,277,495.3,277z" />
                                                </g>
                                            </g>
                                        </svg>
                                    </div><!-- .service-icon -->
                                    <div class="service-text">
                                        <h4 class="title">Data Analycis</h4>
                                        <p>Lorem ipsum dolor sit amet, conse ctetur adipisicing elit, sed do eiusm lod tempor incididunt ctechtner.</p>
                                    </div><!-- .service-text -->
                                </div><!-- .service -->
                            </div><!-- .col -->
                        </div><!-- .row -->
                    </div><!-- .section-content -->
                </div><!-- .container -->
            </section><!-- .section -->
            <section class="section section-feature pb-0">
                <div class="container">
                    <div class="row g-gs justify-content-between align-items-center">
                        <div class="col-lg-6">
                            <div class="img-block">
                                <img src="/images/gfx/d.png" alt="">
                            </div>
                        </div><!-- .col -->
                        <div class="col-lg-5">
                            <div class="text-block">
                                <h2 class="title mb-3">Topics, Notes And Action Items All In One Place </h2>
                                <ul class="list list-lg list-purple list-checked-circle gy-4">
                                    <li class="ps-5"><strong>Amazing Features</strong>: For Enhanced performance we use Lite Speed web server, HTTP/2,PHP7.We make your Everything stays organized by to pic.Need to discuss a topic further.</li>
                                    <li class="ps-5"><strong>Topics, notes and action items</strong>: Everything stays organized by topic.Need to discuss a topic further? Set it to Revisit and it.We make your everything stays organized.</li>
                                </ul>
                            </div><!-- .text-block -->
                        </div><!-- .col -->
                    </div><!-- .row -->
                </div><!-- .container -->
            </section><!-- .section -->
            <section class="section section-feature pb-0">
                <div class="container">
                    <div class="row g-gs flex-row-reverse justify-content-between align-items-center">
                        <div class="col-lg-6">
                            <div class="img-block">
                                <img src="/images/gfx/e.png" alt="Dashlite">
                            </div>
                        </div><!-- .col -->
                        <div class="col-lg-5">
                            <div class="text-block">
                                <h2 class="title mb-3">Amazing Tool For Creative Profesional</h2>
                                <p>Bring to the table win-win survival strategies to ensure proactive domination.At the end of the day, going forward, a new normal that has envolved from generation X ison the runway heading toward</p>
                                <ul class="list list-lg list-purple list-checked-circle pt-1">
                                    <li class="ps-5 pb-1"><strong>Where meetings come together in one</strong></li>
                                    <li class="ps-5 pb-1"><strong>Workspaces forevery meeting.</strong></li>
                                    <li class="ps-5 pb-1"><strong>Amazing Feature.For Enhanced performance.</strong></li>
                                </ul>
                            </div><!-- .text-block -->
                        </div><!-- .col -->
                    </div><!-- .row -->
                </div><!-- .container -->
            </section><!-- .section -->
            <section class="section section-pricing pb-0" id="pricing">
                <div class="container">
                    <div class="row justify-content-center">
                        <div class="col-xl-6 col-md-8 col-sm-10">
                            <div class="section-head text-center">
                                <h2 class="title fw-medium">Choose Your Plan</h2>
                                <p>Best plan dolor sit amet, consectetur adipiscing elit. Commodo at fringilla dictum ut ante habitasse quis. Ut integer in </p>
                            </div><!-- .section-head -->
                        </div><!-- .col -->
                    </div><!-- .row -->
                    <div class="row justify-content-center g-gs">
                        <div class="col-xl-4 col-lg-4 col-sm-6">
                            <div class="pricing pricing-s3 pricing-s3-featured card card-shadow card-bordered round-xl">
                                <div class="card-inner card-inner-lg">
                                    <h4 class="title pb-2 fw-normal">Basic</h4>
                                    <h1 class="pb-4 fw-medium"><sub>$</sub>15</h1>
                                    <ul class="list list-success list-check gy-2">
                                        <li><strong>6 Dashboard</strong></li>
                                        <li><strong>24/7 Live Support</strong></li>
                                        <li><strong>20 screen</strong></li>
                                        <li><strong>Tech Support</strong></li>
                                        <li><strong>Clean Design</strong></li>
                                    </ul>
                                    <div class="pricing-action">
                                        <a href="#" class="btn btn-outline-light btn-lg btn-block"><span>Buy Plan</span></a>
                                    </div>
                                </div>
                            </div>
                        </div><!-- .col -->
                        <div class="col-xl-4 col-lg-4 col-sm-6">
                            <div class="pricing pricing-s3 pricing-featured card card-shadow card-bordered round-xl">
                                <div class="card-inner card-inner-lg">
                                    <h4 class="title pb-2 fw-normal">Premium</h4>
                                    <h1 class="pb-4 fw-medium"><sub>$</sub>20</h1>
                                    <ul class="list list-success list-check gy-2">
                                        <li><strong>16 Dashboard</strong></li>
                                        <li><strong>24/7 Live Support</strong></li>
                                        <li><strong>20 screen</strong></li>
                                        <li><strong>Tech Support</strong></li>
                                        <li><strong>Analytics & Reports</strong></li>
                                    </ul>
                                    <div class="pricing-action">
                                        <a href="#" class="btn btn-outline-light btn-lg btn-block"><span>Buy Plan</span></a>
                                    </div>
                                </div>
                            </div>
                        </div><!-- .col -->
                        <div class="col-xl-4 col-lg-4 col-sm-6">
                            <div class="pricing pricing-s3 pricing-s3-featured card card-shadow card-bordered round-xl">
                                <div class="card-inner card-inner-lg">
                                    <h4 class="title pb-2 fw-normal">Ultimate</h4>
                                    <h1 class="pb-4 fw-medium"><sub>$</sub>30</h1>
                                    <ul class="list list-success list-check gy-2">
                                        <li><strong>6 Dashboard</strong></li>
                                        <li><strong>24/7 Live Support</strong></li>
                                        <li><strong>20 screen</strong></li>
                                        <li><strong>Tech Support</strong></li>
                                        <li><strong>Clean Design</strong></li>
                                    </ul>
                                    <div class="pricing-action">
                                        <a href="#" class="btn btn-outline-light btn-lg btn-block"><span>Buy Plan</span></a>
                                    </div>
                                </div>
                            </div>
                        </div><!-- .col -->
                    </div><!-- .row -->
                </div><!-- .container -->
            </section><!-- .section -->
            <section class="section section-about" id="story">
                <div class="container">
                    <div class="row align-items-center justify-content-between g-gs">
                        <div class="col-lg-6">
                            <div class="img-block">
                                <img src="/images/gfx/f.png" alt="img">
                            </div>
                        </div><!-- .col -->
                        <div class="col-xl-5 col-lg-6">
                            <div class="text-block">
                                <h2 class="title fw-medium">Story of Making DashLite</h2>
                                <p>In marketplace, most of dashboard are generic. On other hand developers and programmers faced lots problem to build their application because those generic dashboard does not provide real-use-case pages. To solve the problem, Softnio Team make a vision.</p>
                                <p>Our vision is so simple. Create the largest and the most comprehensive conceptual base dashboard including great UI/UX.</p>
                                <h6 class="overline-title">Designed and developed by</h6>
                                <div class="row gy-3">
                                    <div class="col-sm-6">
                                        <div class="user user-s1">
                                            <div class="img">
                                                <img class="img-circle sm" src="/images/client/sq-b.jpg" alt="">
                                            </div><!-- img-->
                                            <div class="info">
                                                <h6 class="name">Abu Bin Ishityak</h6>
                                                <div class="role text-uppercase">Role as Designer</div>
                                            </div>
                                        </div><!-- user -->
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="user user-s1">
                                            <div class="img">
                                                <img class="img-circle sm" src="/images/client/sq-a.jpg" alt="">
                                            </div><!-- img-->
                                            <div class="info">
                                                <h6 class="name">Softnio Team</h6>
                                                <div class="role text-uppercase">Role as Designer</div>
                                            </div>
                                        </div><!-- user -->
                                    </div>
                                </div>
                            </div><!-- .text-block -->
                        </div><!-- .col -->
                    </div><!-- .row -->
                </div><!-- .container -->
            </section><!-- .section -->
            <section class="section section-cta bg-lighter" id="cta">
                <div class="container">
                    <div class="row justify-content-center text-center">
                        <div class="col-xl-6 col-lg-7 col-md-8">
                            <div class="text-block is-compact">
                                <h2 class="title">Experience Our Dashlite Service</h2>
                                <p>Our vision is so simple. Create the largest and the most comprehensive conceptual base dashboard including great UI/UX ui/ux.</p>
                                <ul class="btns-inline">
                                    <li>
                                        <a href="#" class="btn btn-lg btn-primary">Get Dashlite</a>
                                    </li>
                                </ul>
                            </div>
                        </div><!-- ,col -->
                    </div><!-- .row -->
                </div><!-- .container -->
            </section><!-- .section -->
            <footer class="footer bg-dark is-dark section section-sm" id="footer">
                <div class="container">
                    <div class="row g-3 align-items-center">
                        <div class="col-md-3">
                            <div class="footer-logo">
                                <a href="html/index.html" class="logo-link">
                                    <img class="logo-light logo-img" src="/images/logo.png" srcset="/images/logo2x.png 2x" alt="logo">
                                    <img class="logo-dark logo-img" src="/images/logo-dark.png" srcset="/images/logo-dark2x.png 2x" alt="logo-dark">
                                </a>
                            </div><!-- .footer-logo -->
                        </div><!-- .col -->
                        <div class="col-md-9 d-flex justify-content-md-end">
                            <ul class="link-inline gx-4">
                                <li><a href="#">All Preview</a></li>
                                <li><a href="#">Features</a></li>
                                <li><a href="#">Doc</a></li>
                                <li><a href="#">Need Help?</a></li>
                            </ul><!-- .footer-nav -->
                        </div><!-- .col -->
                    </div>
                    <div class="row g-3 align-items-center pt-4">
                        <div class="col-md-8">
                            <div class="text-base">&copy; 2022 Dashlite. Template Made by <a class="text-base fw-bold" href="#">Softnio</a></div>
                        </div><!-- .col -->
                        <div class="col-md-4 d-flex justify-content-md-end">
                            <ul class="social">
                                <li><a href="#"><em class="icon ni ni-facebook-f"></em></a></li>
                                <li><a href="#"><em class="icon ni ni-instagram"></em></a></li>
                                <li><a href="#"><em class="icon ni ni-twitter"></em></a></li>
                            </ul><!-- .footer-icon -->
                        </div><!-- .col -->
                    </div><!-- .row -->
                </div><!-- .container -->
            </footer><!-- .footer -->
        </div>
        <!-- main @e -->
    </div>

</template>
<script>
    export default {
        data() {
            return {
                loading: false,
            }
        },

        methods: {
            GoToTerms: function () {
                this.$router.push('/TermsAndCondition')
            }
        }
    }
</script>
